//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useEffect, useCallback, useRef } from 'react';

// *** MUI / STYLE ***
import { useTheme } from '@mui/material/styles';

// === API ===
import { on, removeListener, sendMessageData } from 'api/prokey/prokey.websocket';
import { useFile } from 'pages/FileViewer/components/FileContext/FileContext';
import Styled from 'components/Styled/Styled';
import useOnVisible from 'components/hooks/useOnVisible/useOnVisible';

//#endregion

//-----------------------------------------------------------------
export function Thumbnail( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id } = props;

  const theme = useTheme();

  const { file_id } = useFile();

  const [ image   , setImage   ] = useState( null );
  const [ focused , setFocused ] = useState(false);

  const ref = useRef();

  const has_image = !!image;

  const url = image ? image.url : '';
  const is_selected = image?.is_selected;

  const [is_visible] = useOnVisible(ref)

  const border_style  = focused ? 'solid'  : is_selected ? 'solid'                    : 'none';
  const border_color  = focused ? 'orange' : is_selected ? theme.palette.primary.main :     '';
  const border_width  = focused ? '5px'    : is_selected ? '5px'                      :      0;
  const border_radius = focused ? '6px'    : is_selected ? '6px'                      :      0;

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      borderStyle  : border_style,
      borderColor  : border_color,
      borderWidth  : border_width,
      borderRadius : border_radius,
      display: 'flex',
      justifyContent: 'center',
      margin: '12px',
      width : '170px',
      height : '220px',
    },
    thumbnail: {
      width : '170px',
      height : '220px',
    },
  }

  const THUMBNAIL = {
    style     : _styles.thumbnail,
    src       : url    ,
    alt       : ''     ,
    loading   : 'lazy' ,
    selected  : is_selected,
    onLoad: (e)=>{
    },
    onError: (event) => {
    }
  };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleImage(data) {
      //-----------------------------------------------------------------
      if( id !== data.id ) return;
      setImage( data )
      if( !data.is_selected || ref.current == null ) return;
      ref.current.scrollIntoView({ behavior: "instant", block: "center", inline: "nearest" });
      ref.current.focus();
    }

    on( 'FILE_IMAGE', handleImage )

    return () => {
      removeListener( 'FILE_IMAGE', handleImage );
    }
  }, [id, ref] );
    
  useEffect( () => {
    function handleFocus(data) {
      if( data.id !== id && focused ) {
        setFocused( false );
      };
      if( data.id !== id ) return;
      setFocused( true );
      ref.current.scrollIntoView({ behavior: "instant", block: "center", inline: "nearest" });
      ref.current.focus();
    }

    on( 'FILE_IMAGE_FOCUS', handleFocus );

    return () => {
      removeListener( 'FILE_IMAGE_FOCUS', handleFocus );
    }
  }, [id, focused] );
  
  useEffect( () => {
    if(!is_visible) return;
    sendMessageData( 'FILE_REQUEST_IMAGE', { file_id, image_id: id } );
  }, [id,is_visible] )

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onMouseDown(event) {
    //-----------------------------------------------------------------
    // Left mouse button
    if( event.button === 0 && event.ctrlKey ) {
      sendMessageData( 'FILE_IMAGE_SELECT', { file_id, images: [id], is_selected: !image.is_selected, is_multi: true } );
    }
    else if( event.button === 0 ) {
      sendMessageData( 'FILE_IMAGE_SELECT', { file_id, images: [id], is_selected: !image.is_selected } );
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------

    return (
      <Styled styles={[ { width: 'fit-content', height: 'fit-content'} ]}>
        <Styled styles={[{width: 'fit-content', height: 'fit-content'}, { paddingLeft: '12px' }]}>
          Page: {image?.number}
        </Styled>
        <Styled ref={ref} styles={[_styles.container]} onMouseDown={onMouseDown} >
          {
            !has_image ? (
              <div>Loading...</div>
            ) : (
            <img { ...THUMBNAIL } />
            )
          }
        </Styled>

      </Styled>
    )
  }

  //#endregion

  return display();
};